import global from '../global'

const dashboardIncomeOverview = global.serverUrl + '/backstage/home/income/overview'
const dashboardIncomeChart = global.serverUrl + '/backstage/home/income/chart'
const dashboardIncomeDealer = global.serverUrl + '/backstage/home/income/dealer'
const dashboardUserOverview = global.serverUrl + '/backstage/home/user/overview'
const dashboardOpusOverview = global.serverUrl + '/backstage/home/opus/overview'
const dashboardIncomeTrend = global.serverUrl + '/backstage/home/income/trend'
export default {
  dashboardIncomeOverview,
  dashboardIncomeChart,
  dashboardIncomeDealer,
  dashboardUserOverview,
  dashboardOpusOverview,
  dashboardIncomeTrend
}



// WEBPACK FOOTER //
// ./src/config/api/home.js